export function formatPhoneNumber(phoneNumber?: string | number | null) {
  if (phoneNumber === undefined || phoneNumber === null) {
    return '';
  }

  const value = String(phoneNumber).trim();

  if (!value) {
    return '';
  }

  const digits = value.replace(/\D/g, '');
  const localDigits = digits.startsWith('61') && digits.length === 11 ? `0${digits.slice(2)}` : digits;

  if (/^04\d{8}$/.test(localDigits)) {
    return `${localDigits.slice(0, 4)} ${localDigits.slice(4, 7)} ${localDigits.slice(7)}`;
  }

  if (/^0[2378]\d{8}$/.test(localDigits)) {
    return `${localDigits.slice(0, 2)} ${localDigits.slice(2, 6)} ${localDigits.slice(6)}`;
  }

  if (/^13\d{4}$/.test(localDigits)) {
    return `${localDigits.slice(0, 2)} ${localDigits.slice(2, 4)} ${localDigits.slice(4)}`;
  }

  if (/^(1300|1800)\d{6}$/.test(localDigits)) {
    return `${localDigits.slice(0, 4)} ${localDigits.slice(4, 7)} ${localDigits.slice(7)}`;
  }

  return value;
}
